export default __webpack_public_path__ + "media/siteware/favicon-180-9e9d449758c8382bfa9193d272aad245.png";